<template>
  <div id="app" class="container is-fluid">
    <top-bar />
    <!-- Left Panel + View Component -->
    <router-view />
  </div>
</template>

<script>
import TopBar from 'components/topBar'

export default {
  components: { TopBar }
}
</script>

<style>
/* Import CSS Files */
@import '~assets/css/base.css';
</style>
